import { createContext } from 'react';

export type TimeDisplayMode = 'auto' | 'onfocus' | 'always' | 'never';

export interface DateRangePickerContextValue {
  timeDisplayMode: TimeDisplayMode;
  readOnly: boolean;
  /**
   * If `true`, the date range input will render clock time inputs for each date input.
   */
  includeTimeInputs: boolean;
  /**
   * Optional flag to enable the new calendar dimensions.
   * TODO(jb): Delete along with `AppDatePickerTimeInputs` | `app-date-picker-time-inputs`
   * */
  v2?: boolean;
}

export const DateRangePickerContext = createContext<DateRangePickerContextValue>({
  timeDisplayMode: 'auto',
  readOnly: false,
  includeTimeInputs: false,
  v2: false,
});
